

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import animateScrollTo from 'animated-scroll-to';
import trunctext from 'trunc-text';
import TrackVisibility from 'react-on-screen';
import NewsItemComponent from '../containers/NewsItemContainer';
import debouncer from '../../../helpers/redux-breakpoint-ssr/debouncer';
import HeaderTags from '../../../common/headerTags/HeaderTags';
import { trackTagHit } from '../../../helpers/Tracking';
import Spinner from '../../../common/Spinner/Spinner';

class NewsPageTagsComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tagSlug: this.props.match.params.slug,
        };

        this._scrollRequest = this._scrollRequest.bind(this);

        this.callbackDebounce = debouncer(this._scrollRequest, 100);
    }

    componentDidMount() {
        animateScrollTo(0, { speed: 700 });

        this.props.getDataNewsByTagIfNeeded(12, 0, this.state.tagSlug);

        if (window.addEventListener) {
            window.addEventListener('scroll', this.callbackDebounce);
        }

        // log the view to our database
        trackTagHit(this.state.tagSlug);
    }

    componentWillUnmount() {
        if (window.removeEventListener) {
            window.removeEventListener('scroll', this.callbackDebounce);
        } else if (window.detachEvent) {
            window.removeEventListener('scroll', this.callbackDebounce);
        }
    }


    _mapNewsTag = (newsTagData) => {
        if (newsTagData) {
            let indexNews = 0;

            // eslint-disable-next-line no-unused-vars
            return newsTagData.map((data, index) => {
                indexNews += 1;

                const isFeatured = false;

                if (indexNews % 8 === 0 && indexNews !== 0) {
                    return ([
                        <TrackVisibility key={`tracking ${data.id}`} className="newsItemWrapper">
                            <NewsItemComponent
                                key={data.slug}
                                isFeatured={isFeatured}
                                data={data}
                            />
                        </TrackVisibility>,
                    ]);
                }

                return (
                    <TrackVisibility key={`tracking ${data.id}`} className="newsItemWrapper">
                        <NewsItemComponent
                            key={data.slug}
                            isFeatured={isFeatured}
                            data={data}
                        />
                    </TrackVisibility>
                );
            });
        }
    }

    _scrollRequest() {
        const y = window.scrollY;
        const altura = window.innerHeight;
        const body = document.body; const
            html = document.documentElement;
        const height = Math.max(body.scrollHeight, body.offsetHeight,
            html.clientHeight, html.scrollHeight, html.offsetHeight);
        const diff = height - altura - y;
        const initNews = this.props.newsTagData.length;
        const moreQtdNews = 16;

        if (diff <= 1000 && this.state.tagSlug && initNews !== 0) {
            this.props.getDataNewsByTagIfNeeded(moreQtdNews, initNews, this.state.tagSlug);
        }
    }

    render() {
        const tagTitle = this.props.currentTagTitle || this.state.tagSlug;
        const newsTagData = this.props.newsTagData;
        const headerTags =
        {
            title: `Saiba tudo sobre ${trunctext(tagTitle, 32)}`, // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
            meta:
            {
                description: `Fique por dentro das Principais Notícias sobre ${tagTitle}. Antena 1, a rádio online mais ouvida do Brasil`,
                keywords: `informação, compilação, ${tagTitle}`,
                'og:title': `Saiba tudo sobre ${tagTitle}`,
                'og:description': `Fique por dentro das Principais Notícias sobre ${tagTitle}. Antena 1, a rádio online mais ouvida do Brasil.`,
                'og:image': 'https://a1media.antena1.com.br/image/share/noticias.png',
            },
        };

        return (
            <React.Fragment>
                <HeaderTags title={headerTags.title} meta={headerTags.meta} />
                <section className="sectionNewsTag">
                    <header>
                        <h1 className="tw-uppercase tw-text-black tw-font-bold tw-text-xl md:tw-text-2xl lg:tw-text-3xl">
                            NOTÍCIAS SOBRE
                            {' '}
                            {tagTitle}
                        </h1>
                        <p className="tw-text-center tw-mt-1 tw-text-base">Veja essas e outras notícias da Antena 1</p>
                    </header>
                    <div className="containerNewsTagPage">
                        {this.props.isLoading ? (
                            <div className="tw-col-span-4 tw-flex tw-items-center tw-justify-center">
                                <Spinner />
                            </div>
                        ) : (
                            this._mapNewsTag(newsTagData)
                        )}
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

NewsPageTagsComponent.propTypes = exact({
    getDataNewsByTagIfNeeded: PropTypes.func,
    newsTagData: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    // noticeText: PropTypes.string,
    match: PropTypes.shape({
        params: PropTypes.shape({
            slug: PropTypes.string,
        }),
    }),
    currentTagTitle: PropTypes.string,
    /* eslint-disable react/no-unused-prop-types */
    // Injected through withRouter but not used
    history: PropTypes.object,
    location: PropTypes.object,
    staticContext: PropTypes.object,
    /* eslint-enable react/no-unused-prop-types */
});

export default NewsPageTagsComponent;
